/**
 * DO NOT import this file directly from another project. If you go, a bug in
 * Vite causes the module to get loaded twice, causing there to be two separate
 * context instances.
 */
import React, { createContext } from "react";

/**
 * Context used to pass down element refs from nav menu to menu items
 */
export const NavMenuRefsContext = createContext<{
    fullBleedRef: React.RefObject<HTMLDivElement> | null;
    navLinksRef: React.RefObject<HTMLUListElement> | null;
}>({
    fullBleedRef: null,
    navLinksRef: null,
});

export const NavMenuRefsProvider = NavMenuRefsContext.Provider;
